import { useMutation } from "react-query";
import { editSingleCamera } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleCamera = () => {
  return useMutation(editSingleCamera, {
    onSuccess: (data) => {
      if (data.status >= 400) {
        throw new Error(data.data || "Request failed");
      }
    },
    onError: (error) => {},
    useErrorBoundary: false,
  });
};
export default useEditSingleCamera;
